module.exports = __webpack_public_path__ + "img/19.92076cb3.png";